import React from 'react';

import SwitcherProvider from '@common/react/components/Core/SwitcherProvider/SwitcherProvider';

import { AppointmentStatus } from '@app/objects/Appointment';
import { storeName, typeName } from '@app/components/UI/AppointmentStatus/defaultOptions';

export const StatusNotificationHandler: React.FC = () => {
	return <SwitcherProvider<AppointmentStatus>
		storeName={storeName}
		type={typeName}
		getObjectFromNotification={(data) => data.status}
		notificationObjectType="Appointment"
	/>;
};
